import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=4c804e2b&scoped=true&"
import script from "./Talk.vue?vue&type=script&lang=js&"
export * from "./Talk.vue?vue&type=script&lang=js&"
import style1 from "./Talk.vue?vue&type=style&index=1&id=4c804e2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c804e2b",
  null
  
)

export default component.exports